import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RoutedEntityPage } from './RoutedEntityPage';
export var EntityItemCreatePage = function (_a) {
    var iconProvider = _a.iconProvider, subTitleProvider = _a.subTitleProvider, titleProvider = _a.titleProvider, entityStateProvider = _a.entityStateProvider, editor = _a.editor;
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var navModelItem = {
        text: titleProvider({ pageName: 'create' }),
        subTitle: subTitleProvider({ pageName: 'create' }),
        url: '.',
        icon: iconProvider({ pageName: 'create' })
    };
    var navModel = {
        main: navModelItem,
        node: navModelItem
    };
    return (React.createElement(RoutedEntityPage, { model: navModel }, editor({
        item: entityStateProvider.props.initialState.example,
        afterSave: function (values) {
            dispatch(entityStateProvider.loadState());
            navigate("../item/" + values.itemId);
        }
    })));
};
//# sourceMappingURL=EntityItemCreatePage.js.map